<ion-header title="{{currentTitle()}}">
  <ion-toolbar>
    <i class="navbar-brand-logo cl-black" [ngClass]="{'isIos' : isIOS, 'isAndroid' : isAndroid}" slot="start" title="" [routerDirection]="back" [routerLink]="currentUrl() === '/sign-in' ? undefined : ['/print-jobs']"></i>
    <span class="title-text" [ngClass]="{'isIos' : isIOS, 'isAndroid' : isAndroid}">Printix</span>
    <ion-title class="title-container" title="{{currentTitle()}}"  mode="ios" *ngIf="currentTitle()">{{currentTitle() | translate}}</ion-title>
    <ion-menu-button slot="end" *ngIf="menuToggleRight" title="menu">
      <i class="icon-menu-toggle cl-grey" [ngClass]="{'isIos' : isIOS}"></i>
    </ion-menu-button>
  </ion-toolbar>
</ion-header>
